import { AddIcon } from "@chakra-ui/icons";
import { Badge, Box, Button, Flex, HStack, IconButton, Menu, MenuButton, MenuItem, MenuList, Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay, Spinner, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FaMapMarkerAlt, FaRoute } from "react-icons/fa";
import { useUITheme } from "../../context/ThemeContext";
import Itinerary from "./Itinerary";
import TransportItinerary from "./TransportItinerary";
import { STOP_CATEGORIES } from "../../features/planner/categories";

export default function ItineraryModal({ isOpen, onClose, combinedStops, distance, time, travelMethod, routeLegs = [], onMoveStop, onSelectStop, onSelectLeg, onRemoveStop, onRegenerateStop, onAddStop, updatingStopId }) {
  const theme = useUITheme();
  const [view, setView] = useState("stops");
  useEffect(() => { if (!isOpen) setView("stops"); }, [isOpen]);
  return (
    <Modal isOpen={isOpen} onClose={onClose} motionPreset="slideInBottom" scrollBehavior="inside">
      <ModalOverlay bg="transparent" />
      <ModalContent position="fixed" bottom={0} m={0} w={{ base: "100%", md: "520px" }} maxW="100%" h="82dvh" maxH="82dvh" bg={theme.bg} color={theme.text} border={`1px solid ${theme.accent}`} borderBottomWidth={0} borderTopRadius="3xl" overflow="hidden" boxShadow="0 -18px 55px rgba(15,23,42,.18)">
        <Box w="44px" h="5px" bg={theme.accent} opacity={0.45} borderRadius="full" mx="auto" mt={4} />
        <ModalHeader px={6} pt={5} pb={2}>
          <Flex align="center" justify="space-between" gap={4}>
            <Box>
              <Text fontSize="2xl" fontWeight="extrabold">Your itinerary</Text>
              <Text fontSize="sm" fontWeight="normal" opacity={0.65}>Review the route · use arrows to reorder</Text>
            </Box>
            <Menu placement="bottom-end">
              <MenuButton
                as={IconButton}
                aria-label="Add a stop"
                icon={updatingStopId === "__adding__" ? <Spinner size="sm" /> : <AddIcon />}
                isRound
                isDisabled={!!updatingStopId}
                bg={theme.primary}
                color="white"
                _hover={{ bg: theme.accent }}
              />
              <MenuList bg={theme.bg} borderColor={theme.accent} zIndex={2000} maxH="60vh" overflowY="auto">
                {STOP_CATEGORIES.map(({ id, label, icon: Icon, color }) => (
                  <MenuItem key={id} icon={<Icon color={color} />} bg={theme.bg} _hover={{ bg: `${theme.accent}22` }} onClick={() => onAddStop?.(id)}>Add {label.toLowerCase()}</MenuItem>
                ))}
              </MenuList>
            </Menu>
          </Flex>
        </ModalHeader>
        <HStack spacing={2} px={6} py={3} wrap="wrap">
          <Badge borderRadius="full" px={3} py={2}>{combinedStops.length} STOPS</Badge>
          {distance && <Badge borderRadius="full" px={3} py={2}>{distance}</Badge>}
          {time && <Badge borderRadius="full" px={3} py={2}>{time}</Badge>}
          {travelMethod && <Badge borderRadius="full" px={3} py={2} bg={theme.primary} color="white">{travelMethod}</Badge>}
        </HStack>
        <HStack mx={6} mb={2} p={1} spacing={1} border={`1px solid ${theme.accent}`} borderRadius="xl" bg={`${theme.accent}0D`}>
          <Button flex="1" size="sm" leftIcon={<FaMapMarkerAlt />} bg={view === "stops" ? theme.primary : "transparent"} color={view === "stops" ? "white" : theme.text} _hover={{ bg: view === "stops" ? theme.primary : `${theme.accent}22` }} onClick={() => setView("stops")}>Stops</Button>
          <Button flex="1" size="sm" leftIcon={<FaRoute />} bg={view === "transport" ? theme.primary : "transparent"} color={view === "transport" ? "white" : theme.text} _hover={{ bg: view === "transport" ? theme.primary : `${theme.accent}22` }} onClick={() => setView("transport")}>Transport</Button>
        </HStack>
        <ModalBody px={5} pt={2} pb="calc(env(safe-area-inset-bottom, 0px) + 24px)">
          {combinedStops.length ? (view === "stops" ? <Itinerary combinedStops={combinedStops} routeLegs={routeLegs} onMoveStop={onMoveStop} onSelectStop={onSelectStop} onRemoveStop={onRemoveStop} onRegenerateStop={onRegenerateStop} updatingStopId={updatingStopId} /> : <TransportItinerary combinedStops={combinedStops} routeLegs={routeLegs} onSelectLeg={onSelectLeg} />) : <Text>No stops in your itinerary yet.</Text>}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
